module.exports = __webpack_public_path__ + "img/BH.f715f49e.svg";